
import { Component, Vue, Watch } from 'vue-property-decorator';
import { OrderItem, SapProduct } from '@/api/model';
import SelectProductGroup from '@/components/orders/SelectProductGroup.vue';
import ProductSearchBar from '@/components/orders/ProductSearchBar.vue';
import OrderCard from '@/components/orders/OrderCard.vue';
import { ProductGroup } from '@/store/OrderStore';
import NewOrderFooter from '@/components/orders/new-order/NewOrderFooter.vue';

@Component({
  components: {
    NewOrderFooter,
    SelectProductGroup,
    ProductSearchBar,
    OrderCard,
  },
})
export default class SelectProducts extends Vue {
  get groups(): ProductGroup[] {
    return this.$store.getters['order/productGroups'](true);
  }

  get groupLabels(): string[] {
    const all = Object.keys(this.groups);
    const filter = this.$store.state.order.filterGroups;
    if (filter.size === 0) {
      return all;
    }
    return all.filter((group) => filter.has(group));
  }

  // Unavailable products in the cart
  get unavailableProducts(): OrderItem[] {
    const availableProducts = this.$store.state.order.products;
    const items = this.$store.state.order.cart.OrderItems;
    if (!items) {
      return [];
    }
    return items.filter(
      (item: OrderItem) =>
        !availableProducts.find(
          (p: SapProduct) => p.ProductNr === item.ProductNr,
        ),
    );
  }

  get loading(): boolean {
    return (
      this.groupLabels.length === 0 &&
      this.$store.state.order.productSearchQuery === ''
    );
  }

  handleCartChanged() {
    // Set flag so suggestion can be reset after next is clicked
    this.$store.commit('order/setCartChanged', true);
  }

  @Watch('unavailableProducts', { immediate: true })
  unavailableProductsChanged(items: OrderItem[]) {
    if (!items || !items.length) {
      return;
    }
    // Show a dialog if there are unavailable products in the cart
    const title = this.$tc(
      'orders.new.products-unavailable.title',
      items.length,
    );
    const label = this.$t('orders.new.products-unavailable.item-label');
    const listContent = items
      .map((i) => `<li>${i.ItemText} - ${label}</li>`)
      .join('');
    const itemList = `<ul class="has-text-danger">${listContent}</ul>`;
    const message = `<div class="content">${itemList}
          <p>${this.$t('orders.new.products-unavailable.message') as string}</p>
          </div>`;
    this.$buefy.dialog.alert({
      title,
      message,
      confirmText: this.$t('orders.new.products-unavailable.button') as string,
      onConfirm: () => {
        // Remove unavailable items from cart
        this.$store.commit('order/removeCartItems', items);
      },
    });
  }
}
